<template>
    <div class="screen">
        <h1>Atualização de sistema.</h1>
        <p v-if="!loadingChecando">
            Estamos realizando uma atualização na plataforma de vendas, aguarde alguns minutos...<br>
            A tela será recarregada automaticamente no fim da atualização.
        </p>
        <p v-else>
            Checando status da atualização...
        </p>
        <div class="icon">
            <img class="spinner" src="../assets/img/update.svg" alt="Atualizando sistema" width="80" height="80" />
        </div>
    </div>
</template>

<script>
  import { formatTempoRestante } from '@/plugins/helpers'
  import router from '../router'
  import session from '@/plugins/session'

  export default {
    name: 'Deploying',
    data () {
      return {
        tempo: 60,
        interval: null,
        loadingChecando: false
      }
    },
    computed: {
      tempoRestante () {
        return formatTempoRestante(this.tempo)
      }
    },
    mounted () {
      this.startCountdown()
    },
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {
      startCountdown () {
        this.interval = setInterval(() => {
          if (this.tempo > 0) {
            this.tempo--
          } else {
            clearInterval(this.interval)
            this.checkAgain()
          }
        }, 1000)
      },
      async checkAgain () {
        this.loadingChecando = true
        try {
          const { data } = await this.$http.get('/verifica-deploy')
          this.$store.commit('setDeployStatus', data.em_deploy)
          if (data.em_deploy) {
            this.tempo = 60
            this.loadingChecando = false
            this.startCountdown()
          } else {
            const isPainel = session.get('sessao_painel') === true
            this.loadingChecando = false
            router.push({ name: isPainel ? 'painel-logout' : 'logout' })
          }
        } catch (e) {
          this.tempo = 60
          this.loadingChecando = false
          this.startCountdown()
        }
      }
    }
  }
</script>

<style scoped>
.screen {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.96);
  padding: 40px;
  z-index: 9999999999;
  text-align: center;
}

 .screen > .icon {
  margin-bottom: 30px;
}

.spinner {
  animation: spin 2s linear infinite;
  transform-origin: 50% 50%;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

 .screen > h1 {
  font-size: 24px;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
}

 .screen > p {
  font-size: 15px;
  color: #444;
  font-weight: 400;
  line-height: 1.5;
}
</style>
